import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import { Link,useHistory } from 'react-router-dom';
const ShowError = (props) => {

    const history = useHistory();
    //alert(props.passerror)
    const [state, setState] = useState({
        show: true,
        message: '',
        passerror:true,
    })
    useEffect(() => {
        setState({ ...state, message: props.message,passerror:props.passerror, })
    }, [props.message])
    const handleClose = (redirectpath) => {
        setState({ ...state, show: false })
        props.toggleModal()
        //alert(redirectpath)
        history.push(redirectpath)
    }

    

    const moveNext = (status,pagepath,redirectpath) => {
        
        
             history.push(redirectpath)
 
         
     }
    return (
        <React.Fragment>
            <Modal show={state.show} onHide={handleClose}>
                <Modal.Body>
                    <div className="popup text-center">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                       
                        <p><span className="fbold">{state.message}</span></p>
                       {props.datarefresh ? <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => handleClose(props.dataredirectpath)}>OK</button>:<button type="button" onClick={() => moveNext(props.datastatus,props.datapagepath,props.dataredirectpath)} className="btn btn-primary" data-dismiss="modal">OK</button>}
                    </div>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default ShowError